import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button, Alert, Card, CardContent } from '@mui/material';
import { apiService } from '../services/api';

const TestAPI: React.FC = () => {
  const [mentors, setMentors] = useState<any[]>([]);
  const [courses, setCourses] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const testAPIs = async () => {
    setLoading(true);
    setError('');
    
    try {
      console.log('Testing API calls...');
      
      // Test basic API connectivity first
      console.log('Testing basic API connectivity...');
      const testResponse = await fetch('http://localhost:8000/api/v1/test/');
      const testData = await testResponse.json();
      console.log('Basic API test result:', testData);
      
      // Test mentors API
      console.log('Testing mentors API...');
      const mentorsResp = await apiService.getPublishedMentors(1, 100);
      setMentors(mentorsResp.results);
      console.log('Mentors result:', mentorsResp);
      
      // Test courses API
      console.log('Testing courses API...');
      const coursesResp = await apiService.getPublishedCourses(1, 100);
      setCourses(coursesResp.results);
      console.log('Courses result:', coursesResp);
      
    } catch (err: any) {
      console.error('API Test Error:', err);
      setError(err.message || 'API test failed');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    testAPIs();
  }, []);

  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Card>
          <CardContent>
            <Typography variant="h4" gutterBottom>
              API Test Page
            </Typography>
            
            <Button 
              variant="contained" 
              onClick={testAPIs}
              disabled={loading}
              sx={{ mb: 3 }}
            >
              {loading ? 'Testing...' : 'Test APIs Again'}
            </Button>

            {error && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            )}

            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                Mentors ({mentors.length})
              </Typography>
              {mentors.length > 0 ? (
                <Box>
                  {mentors.map((mentor, index) => (
                    <Box key={index} sx={{ p: 2, border: '1px solid #ccc', mb: 1, borderRadius: 1 }}>
                      <Typography><strong>Name:</strong> {mentor.name}</Typography>
                      <Typography><strong>Email:</strong> {mentor.email}</Typography>
                      <Typography><strong>Published:</strong> {mentor.is_published ? 'Yes' : 'No'}</Typography>
                      <Typography><strong>Active:</strong> {mentor.is_active ? 'Yes' : 'No'}</Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography color="text.secondary">No mentors found</Typography>
              )}
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom>
                Courses ({courses.length})
              </Typography>
              {courses.length > 0 ? (
                <Box>
                  {courses.map((course, index) => (
                    <Box key={index} sx={{ p: 2, border: '1px solid #ccc', mb: 1, borderRadius: 1 }}>
                      <Typography><strong>Name:</strong> {course.name}</Typography>
                      <Typography><strong>Price:</strong> ${course.price}</Typography>
                      <Typography><strong>Published:</strong> {course.is_published ? 'Yes' : 'No'}</Typography>
                      <Typography><strong>Active:</strong> {course.is_active ? 'Yes' : 'No'}</Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography color="text.secondary">No courses found</Typography>
              )}
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default TestAPI;
